/*!

=========================================================
* Material Dashboard PRO React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useReducer /*, useEffect */ } from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import { MyContext } from "redux/Context.js";
// import AuthLayout from "layouts/Auth.js";
// import RtlLayout from "layouts/RTL.js";
// import AdminLayout from "layouts/Admin.js";
import Main from "layouts/Main.js";
import { reducer, initialState } from "redux/reducer.js";

import "assets/scss/material-dashboard-pro-react.scss?v=1.8.0";
import "assets/scss/foodiestrip.css";
import "assets/scss/reservation.css";

import i18n from "i18next";
import file from "Language/resources";
import { useTranslation, initReactI18next } from "react-i18next";

const hist = createBrowserHistory();

function App() {
  const [state, dispatch] = useReducer(
    (state, action) => reducer(action, state),
    initialState
  );
  i18n.use(initReactI18next).init({
    resources: file.resources,
    lng: "it",
    fallbackLng: "it",

    interpolation: {
      escapeValue: false
    }
  });

  return (
    <MyContext.Provider value={{ state, dispatch }}>
      <Router history={hist}>
        <link
          rel="stylesheet"
          href="https://unpkg.com/leaflet@1.5.1/dist/leaflet.css"
          integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
          crossOrigin=""
        />
        <script
          src="https://unpkg.com/leaflet@1.5.1/dist/leaflet.js"
          integrity="sha512-GffPMF3RvMeYyc1LWMHtK8EbPv0iNZ8/oTtHPx9/cc2ILxQ+u905qIwdpULaqDkyBKgOaB57QTMg7ztg8Jm2Og=="
          crossOrigin=""
        ></script>
        <meta name="title" content="Touristwallet" />
        <meta
          name="description"
          content="Crea il tuo conto sulla blockchain e paga con moneta virtuale presso le strutture della regione Lazio. Deposita e preleva dal tuo wallet in piena sicurezza e trasparenza grazie alla blockchain. "
        />
        <Switch>
          {/* <Route path="/rtl" component={RtlLayout} />
          <Route path="/auth" component={AuthLayout} /> */}
          <Route path="/" component={Main} />
          {/* <Route path="/admin" component={AdminLayout} /> */}
          {/* <Redirect from="/" to="/main" /> */}
        </Switch>
      </Router>
    </MyContext.Provider>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));
